module.exports = __webpack_public_path__ + "img/_1.2f26fe6f.webp";